<app-option-bar [type]="'TESTSUITE'" [isSettingEnabled]='false'></app-option-bar>
<div class="container-fluid history-wrapper">
  <div class="row">
    <app-filter-options [projects]="myProjects" [users]="users" [executionStatusList]="executionStatusList"
      (searchHandler)="paginateWithFilterParams($event)"></app-filter-options>
    <div class="col-10 inner-content">
      <table class="table table-condensed table-hover table-list-design">
        <thead>
          <tr>
            <th>Name</th>
            <th>Started on</th>
            <th>Ended on</th>
            <th>Environment Mapper</th>
            <th>Executed by</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let testsuiteResult of testSuiteResultList" class="clickable">
            <td><a [routerLink]="['/testsuite',testsuiteResult.execution.executedTaskSqlId,'result']"
                [queryParams]="{noSqlId: testsuiteResult.execution.noSqlId}"
                target="_blank">{{testsuiteResult.name}}</a></td>
            <td>
              <div *ngIf="testsuiteResult.execution.startTime !== null">
                {{testsuiteResult.execution.startTime | localDate}}</div>
              <div *ngIf="testsuiteResult.execution.startTime === null">
                {{testsuiteResult.execution.executedOn | localDate}}</div>
            </td>
            <td>
              <div *ngIf="testsuiteResult.execution.endTime === null">N/A</div>
              <div *ngIf="testsuiteResult.execution.endTime !== null">
                {{testsuiteResult.execution.endTime | localDate}}</div>
            </td>
            <td>
              <div class="overflow-div-td">
                {{ testsuiteResult.environmentMap.name }}
              </div>
            </td>
            <td>{{testsuiteResult.execution.executedBy}}</td>
            <td [ngClass]="testsuiteResult.execution.executionStatus" class="text-capitalize">
              {{testsuiteResult.execution.executionStatus}}</td>
          </tr>
          <tr *ngIf="this.dataNotFound === true">
            <td colspan="6">No data found !!!</td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination section -->
      <div *ngIf="!this.dataNotFound && this.dataLoaded" id="loadmore-box" class="text-center">
        <span *ngIf="this.moreData" class="load-more-button" (click)="loadmore(this.page)">LOAD MORE</span>
      </div>

    </div>
  </div>
</div>